// extracted by mini-css-extract-plugin
export default {"profilePic":"ProfileImage_profilePic__UHtgy","hamburgerIcon":"ProfileImage_hamburgerIcon__iHsk3"};